/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */


import React from 'react';
import { trackEvent } from '../../lib/utils';

const buttonPayStyle = {
  borderRadius: '0',
  padding: '10px 40px',
  color: 'white',
  height: '40px',
};

class EmptyFileDownloader extends React.Component {

  render() {
    let href = `${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.serviceType}/getEmptyDoc`;
    if (this.props.isServiceFromCreator) {
      href = `${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.serviceType}/getEmptyDocForCreatedEservice/`;
    }
    return (
      <a
        className={`btn btn-success pull-${this.props.position} ${this.props.className}`}
        target="_blank"
        href={href}
        style={buttonPayStyle}
        onClick={() => trackEvent({ category: 'download', action: 'click', name: this.props.title || this.props.serviceType })}
      >
        Pobierz wzór wniosku
      </a>
    );
  }

}

export default EmptyFileDownloader;



// WEBPACK FOOTER //
// src/components/EmptyFileDownloader/EmptyFileDownloader.js